import type { ReactNode } from 'react';
import styles from './PageContainer.module.css';

/** Content area under the topbar, with an optional section header row. */
export function PageContainer({
  children,
  actions,
}: {
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className={styles.page}>
      {actions && <div className={styles.actions}>{actions}</div>}
      {children}
    </div>
  );
}
